<template>
  <div id="addSchedule">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect
                    :options="typeSourceSelect.options"
                    :data="typeSourceSelect.data"
                    ref="typeSourceSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <div class="form-group form-row" :class="{
                            'input-valid-error': fileSelectedInput.data.validator && !fileSelectedInput.data.validator.isValid,
                            'no-label': !(fileSelectedInput.options && fileSelectedInput.options.label)}"
                       v-if="typeSourceSelect.data.model == 0 || typeSourceSelect.data.model == 1">
                    <label class="col-form-label col-sm-3" v-html="fileSelectedInput.options.label"></label>
                    <input type="text" :placeholder="fileSelectedInput.options.placeholder"
                           class="form-control col-sm-9" readonly v-model="fileSelectedInput.data.title"
                           @click="chooseFile()" ref="fileSelectedInput"/>
                    <span class="col-sm-3"></span>
                    <div class="valid-error"
                         v-show="!(fileSelectedInput.data.validator ? fileSelectedInput.data.validator.isValid : true)">
                      {{ fileSelectedInput.data.validator ? fileSelectedInput.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                  <BaseSelect v-show="typeSourceSelect.data.model == 2"
                              :options="channelDigitalSelect.options"
                              :data="channelDigitalSelect.data"
                              ref="channelDigitalSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect
                    :options="modeSelect.options"
                    :data="modeSelect.data"
                    ref="modeSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model != 2">
                  <div class="form-group form-row">
                    <label for="dateRanger" class="col-form-label col-sm-3">Ngày bắt đầu - Ngày kết thúc
                      <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                            title="<div class='text-left'><b>- Ngày bắt đầu - ngày kết thúc:</b> Là khoảng thời gian hiệu lực của lịch phát thanh được gửi tới thiết bị. Nếu người dùng muốn đặt lịch cho cả tháng, chọn ngày bắt đầu là ngày 1 đầu tháng đến ngày kết thúc là 30 (hoặc 28,29,31) cuối tháng.
                    <br/><i>Lưu ý:<br/>
                              + Với lịch phát trong nhiều ngày, người dùng nhấn chuột lần đầu để chọn ngày bắt đầu, bấm chọn lần tiếp vào ngày muốn chọn làm ngày kết thúc,
                              lịch phát sẽ được thực thi trong khoảng thời gian được chọn với Thời gian phát tương ứng.<br/>
                              + Với lịch phát trong một ngày duy nhất, người dùng nhấn chuột 2 lần vào cùng 1 ngày mong muốn, hệ thống sẽ tự động nhận ngày bắt đầu và ngày
                              kết thúc tại cùng một ngày, và lịch phát sẽ được thực thi trong duy nhất ngày được chọn.</i></div>">
                       <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <DatePicker
                      id="dateRanger"
                      v-model="dateRange"
                      is-range
                      locale="vi"
                      class="datepicker col-sm-9"
                      :input-props="{ readonly: true }"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                      :min-date="new Date()"
                      :popover="{ visibility: 'click' }"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <input
                          :value="inputValue.start + ' - ' + inputValue.end"
                          v-on="inputEvents.start"
                          class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300 " readonly
                        />
                      </template>
                    </DatePicker>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 1">
                  <BaseSelect
                    :options="modeSchedule.options"
                    :data="modeSchedule.data"
                    ref="modeSchedule">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 1 || modeSelect.data.model == 0">
                  <div class="form-group form-row mb-0"
                       :class="!(validatorRangeTimes ? validatorRangeTimes.isValid : true) ? 'input-error' : ''">
                    <label class="col-form-label col-sm-3">Thời gian phát
                      <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                            title="<div class='text-left'><b>- Thời gian phát :</b> Là khung giờ phát được đặt theo khoảng thời gian hiệu lực
                            (Ngày bắt đầu- ngày kết thúc) cho các thiết bị, người dùng nhấn nút Thêm để tạo mới khung giờ thời gian phát,
                            tiếp tục nhấn chọn vào khung thời gian để chọn thời gian bắt đầu và thời gian kết thúc của lịch phát.
                                <i>Lưu ý: Khi đặt lịch với thời gian phát tương ứng, người dùng chú ý định dạng của Thời gian phát ( định dạng giờ 24) như sau
                                <br/>+ Nếu mong muốn lịch phát là 5 giờ sáng đến 7 giờ sáng, người dùng thêm thời gian phát là 05:00 - 07:00.
                                <br/>+ Nếu mong muốn lịch phát là 5 giờ chiều đến 7 giờ chiều, người dùng thêm thời gian phát là 17:00 - 19:00</i></div>">
                       <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <CCard class="mb-1 col-sm-9" ref="rangeTimes">
                      <CCardBody style="padding-top: 5px !important">
                        <CRow>
                          <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange"
                                :key="each.start.getTime()">
                            <DatePicker
                              mode="time"
                              :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                              :value="each"
                              is-range
                              is24hr
                              :popover="{ visibility: 'click' }"
                              @input="changeTimeRange($event, index)"
                              ref="timeRange">
                              <template v-slot="{ inputValue, inputEvents , togglePopover, hidePopover}">
                                <!--                                <CInput class="btn-time-ranger"-->
                                <!--                                        :value="inputValue.start + ' - ' + inputValue.end"-->
                                <!--                                        v-on="inputEvents.start"-->
                                <!--                                        readonly-->
                                <!--                                />-->
                                <div class="form-group">
                                  <input type="text"
                                         :style="each.isValid ? 'border-color:red!important;' : ''"
                                         class="btn-time-ranger form-control"
                                         :value="inputValue.start + ' - ' + inputValue.end" readonly
                                         v-on="inputEvents.start">
                                </div>
                                <svg
                                  v-c-tooltip.hover="'Xóa'"
                                  class="w-1 h-1 btn-remove-time"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  @click="removeTimeRange(index)"
                                >
                                  <path d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                              </template>
                            </DatePicker>
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol>
                            <CButton color="primary" class="mt-3" @click="addTimeRange()">
                              <i class="fa fa-plus"></i> Thêm
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="sortRangeTime(true)">
                              <i class="fa fa-sort"></i> Sắp xếp
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="timeRange = []">
                              <i class="fa fa-eraser"></i> Xóa tất cả
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                    <span class="col-sm-3"></span>
                    <div class="valid-error" v-show="!(validatorRangeTimes ? validatorRangeTimes.isValid : true)">
                      {{ validatorRangeTimes ? validatorRangeTimes.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 2">
                  <div class="form-group form-row"
                       :class="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker" class="col-form-label col-sm-3">Thời gian kết thúc phát
                      <span class="required">* </span>
                      <span class="explain" id="endTime" data-toggle="tooltip" data-html="true"
                            title="<div class='text-left'>Người dùng chỉ cần nhập thời gian kết thúc lịch phát khẩn cấp, chọn thiết bị thực hiện, thời gian bắt đầu được tính tại thời điểm lịch phát được lưu.</div>">
                       <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <DatePicker
                      ref="endTimeUrgency"
                      id="endTimeUrgencyPicker"
                      mode="time"
                      v-model="endTimeUrgency"
                      :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                      is24hr class="com-sm-8">
                    </DatePicker>
                  </div>
                  <div class="form-row">
                    <div class="col-sm-3"></div>
                    <div class="valid-error col-sm-8" style="padding: unset!important;"
                         v-show="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true)">
                      {{ validatorEndTimeUrgency ? validatorEndTimeUrgency.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8"
                      v-if="modeSchedule.data.model == 0 && modeSelect.data.model == 1">
                  <div class="form-group form-row" ref="selectedDateWeek">
                    <label class="col-form-label col-sm-3">Ngày phát <span
                      class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                            title="<div class='text-left'><b style='color: black'>- Đối với kiểu lịch Theo ngày trong tuần:</b> Người dùng chọn các thứ trong tuần lịch phát có hiệu lực.
                          <br/><i style='color: red'>Ví dụ: trong khoảng thời gian hiệu lực ( Ngày bắt đầu - Ngày kết thúc) 1 tháng,
                          người dùng chỉ chọn thứ 2,3,4,5,6, các ngày thứ 7, chủ nhật trong khoảng thời gian 1 tháng đó sẽ không có lịch phát thanh ra các thiết bị</i></div>">
                       <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <multiselect
                      id="selectedDateWeek"
                      v-model="selectedDateWeek.data.model"
                      placeholder="Ngày phát"
                      label="value"
                      track-by="key"
                      :options="selectedDateWeek.data.items"
                      selectLabel="Chọn"
                      deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn"
                      :close-on-select="false"
                      :multiple="true"
                      :class="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true) ? 'input-error' : ''"
                      class="col-sm-9"
                    >
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>
                    <span class="col-sm-3"></span>
                    <div class="valid-error"
                         v-show="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true)">
                      {{ selectedDateWeek.data.validator ? selectedDateWeek.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8"
                      v-if="modeSelect.data.model == 1 && modeSchedule.data.model == 1">
                  <div class="form-group form-row" ref="rangeDates"
                       :class="!(validatorDates ? validatorDates.isValid : true) ? 'input-error' : ''">
                    <label class="col-form-label col-sm-3">Ngày phát <span
                      class="required">* </span>
                      <span class="explain" id="123" data-toggle="tooltip" data-html="true"
                            title="<div class='text-left'><b style='color: black'>- Đối với kiểu lịch Theo ngày trong tháng:</b> Người dùng chọn các ngày chỉ định
                          trong tháng để lịch phát có hiệu lực.
                          <br/><i style='color: red'>Ví dụ: trong khoảng thời gian hiệu lực ( Ngày bắt đầu - Ngày kết thúc) 1 tháng,
                           người dùng chỉ chọn ngày 1,2,3,4,5,6,7, các ngày còn lại trong khoảng thời gian 1 tháng đó sẽ không có lịch phát thanh ra các thiết bị</i></div>">
                       <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <CCard class="mb-1 col-sm-9">
                      <CCardBody style="padding-top: 5px !important">
                        <DatePicker
                          id="datepicker"
                          mode="date"
                          locale="vi"
                          v-model="selectedDate.date"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :is-required="true"
                          :popover="{ visibility: 'click' }"
                        >
                          <template
                            #default="{
                              inputValue,
                              togglePopover,
                              hidePopover,
                            }"
                          >
                            <div class="flex flex-wrap">
                              <CButton
                                v-for="(each, i) in dates"
                                :key="each.date != null ? each.date.getTime() : new Date().getTime()"
                                color="light"
                                class="mr-3 mt-3 btn-date"
                                style="position: relative"
                                @click.stop=" dateSelected($event, each, togglePopover)"
                                ref="btnDate"
                              >
                                {{
                                  each.date != null ? $helper.formatDateDDMMYYYY(each.date) : $helper.formatDateDDMMYYYY(new Date())
                                }}
                                <div class="btn-remove">
                                  <svg
                                    class="w-1 h-1"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    @click.stop="removeDate(each, hidePopover)"
                                  >
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </div>
                              </CButton>
                            </div>
                          </template>
                        </DatePicker>
                        <CButton color="primary" class="mt-3" :disabled="checkDisableAddDate" @click="addDate">
                          <i class="fa fa-plus"></i> Thêm ngày
                        </CButton>
                        <CButton color="secondary" class="mt-3 ml-2" @click="dates = []">
                          <i class="fa fa-eraser"></i> Xóa tất cả
                        </CButton>
                      </CCardBody>
                    </CCard>
                    <span class="col-sm-3"></span>
                    <div class="valid-error" v-show="!(validatorDates ? validatorDates.isValid : true)">
                      {{ validatorDates ? validatorDates.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <!-- <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect
                    :options="scheduleBySelect.options"
                    :data="scheduleBySelect.data"
                    ref="scheduleBySelect">
                  </BaseSelect>
                </CCol> -->
              </CRow>

              <!-- Đặt lịch theo địa bàn -->
              <!-- <CRow v-if="scheduleBySelect.data.model == 0">
                <CCol xs="12" sm="12" md="12" xl="8" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
                  <BaseSelect :options="districtCodeScheduleInput.options" :data="districtCodeScheduleInput.data"
                              ref="districtCodeScheduleInput"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="!$hasAuthor('ROLE_WARD')">
                  <BaseSelect :options="wardCodeScheduleInput.options" :data="wardCodeScheduleInput.data"
                              ref="wardCodeScheduleInput"></BaseSelect>
                </CCol>
              </CRow> -->
              <!-- Danh sách thiết bị -->
              <BaseFormDevice @change-selected="changeSelectedDevice"
                              @clear:selectedAll="clearSelectedAll"
                              :reset="resetDevice" :isValid="!deviceInput.validator.isValid"
                              @change-valid="changeValidateDevice($event)"></BaseFormDevice>
              <br/>


              <CRow>
                <CCol xs="12" md="12" lg="12" xl="12">
                  <CButton color="primary" @click="submitData()"><i class="fa fa-save"></i> Đặt lịch
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="resetData()"><i class="fa fa-eraser"></i> Làm mới
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="$router.go(-1)"><i class="fa fa-reply"></i> Hủy bỏ
                  </CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          <br v-if="exist.mode == 2"/><span style="color: #ff0303; font-weight: bold;" v-if="exist.mode == 2">
            (Đây là lịch phát khẩn cấp của cấp trên: {{ exist.locationName }}. Nếu xác nhận ghi đè, người dùng sẽ chịu trách nhiệm cho thao tác này)
          </span>
          <br/>
          với các thiết bị:
          <br/>
          <span v-for="i of exist.devices">
            {{ i + '; ' }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button v-if="exist.mode == 2" type="button" class="btn btn-primary" @click="submitConfirm()">
          <i class="fa fa-save"></i> Xác nhận ghi đè lịch
        </button>
        <button v-else type="button" class="btn btn-primary"
                @click="$router.push(`${exist.id}/managed-shedule-detail.html`)">
          <i class="fa fa-eye"></i> Xem lịch đã tồn tại
        </button>
      </template>
    </CModal>

    <FileManagementAddSchedule v-if="chooseFileData.isShowModal"
                               @file:selected="chooseFileSelected($event)"
                               @close-modal="closeModalChooseFile($event)"></FileManagementAddSchedule>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseFormDevice from "@/views/base/BaseFormDevice";
import FileManagementAddSchedule from "@/views/base/FileManagementAddSchedule";

export default {
  name: "ScheduleAdd",
  components: {
    FileManagementAddSchedule,
    BaseFormDevice,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect,
    BaseLoading,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      timeout: 10000
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    return {
      isConfirm: true,
      isSelectedAllDevices: false,
      loading: {value: false},
      minDate: today,
      maxDate: today,
      dates: [],
      selectedDate: {},
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false,
        mode: "",
        locationName: ""
      },
      endTimeUrgency: this.$helper.plusDateTime(10, 'm')._d,
      actionData: {
        model: {
          listFileSelectedId: [],
        },
      },
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
      timeRange: [],
      districtCodeScheduleInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "scheduleDistrictCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeScheduleInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeScheduleInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "scheduleWardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeScheduleInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeScheduleInput.data.items = dataResponse.data;
            }
          }
        }
      },
      scheduleLocationCode: {
        data: {
          name: 'scheduleLocationCode',
          model: ''
        }
      },
      typeSourceSelect: {
        options: {
          label: "Nguồn phát <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Nguồn phát Tập tin âm anh từ kho biên tập:</b> " +
            "Là nguồn phát của tập tin biên tập tại kho lưu trữ, để sử dụng nguồn phát này cho đặt lịch, người dùng cần biên tập tải lên tệp tin tại chức năng " +
            "<i>Quản lý ND & biên tập -> Biên tập nội dung -> Thêm mới</i>" +
            "<br/><b>- Nguồn phát Kênh số hoá:</b> Là nguồn phát đã được số hoá và luôn trực tuyến, ví dụ như Kênh VOV, đài số hoá địa phương tại Huyện, Tỉnh...'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
        },
        data: {
          name: "mode",
          items: [
            {key: "0", value: "Tập tin âm thanh từ kho biên tập"},
            // {key: "1", value: "Tập tin âm thanh chuyển đổi văn bản sang giọng đọc"},
            {key: "2", value: " Kênh số hóa Radio"},
          ],
          model: "0",
        },
      },
      fileSelectedInput: {
        options: {
          label: "Tệp tin <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>Tệp tin:</b> Người dùng chọn tệp tin đã được biên tập tải lên tại kho lưu trữ để đặt lịch." +
            "<br/><i>Lưu ý: để tìm tệp tin cần chọn nhanh và chính xác nhất, người dùng cần chú ý lọc khoảng thời gian ngày tạo bản tin, loại tệp tin và địa bàn tương ứng.</i>'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          placeholder: 'Chọn tệp tin ...'
        },
        data: {
          title: "",
          name: "name",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fileSelectedInput.data.model;
              if (value === "" && (that.typeSourceSelect.data.model == 0 || that.typeSourceSelect.data.model == 1)) {
                this.isValid = false;
                this.errorMessage = "Tệp tin phát thanh không được để trống";
                that.scrollToValidate(that.$refs.fileSelectedInput.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        }
      },
      channelDigitalSelect: {
        options: {
          label: "Kênh số hóa <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Kênh số hoá:</b> Là danh sách các kênh đài phát thanh đã được số hoá và hiển thị khi trực tuyến " +
            "(nguồn phát có tín hiệu và sẵn sàng), người dùng chọn một kênh trong danh sách này để thực hiện đặt lịch'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
          lazyLoad: true,
          'keyField': 'key',
          'valueField': 'value',
          selectAllText: "Chọn kênh số hóa",
        },
        data: {
          name: "channelDigital",
          items: [],
          model: "",
          source: {
            url: '/common/listChannelDigital',
            isJsonContentType: false,
            dataSubmit: function () {
              return {
                name: '',
                locationCode: ''
              }
            },
            response: function (dataResponse) {
              that.channelDigitalSelect.data.items = dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.channelDigitalSelect.data.model;
              if (value === "" && that.typeSourceSelect.data.model == 2) {
                this.isValid = false;
                this.errorMessage = "Kênh số hóa không được để trống";
                that.scrollToValidate(that.$refs.channelDigitalSelect.$el.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      scheduleBySelect: {
        options: {
          label: "Đặt lịch theo <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Đặt lịch theo địa bàn:</b> Là đặt lịch cho tất cả thiết bị trên địa bàn. " +
            "<br/><b>- Đặt lịch theo thiết bị:</b> Là đặt lịch cho các thiết bị được chọn trên địa bàn." +
            "'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "scheduleBy",
          items:
            [
              {key: "0", value: "Đặt lịch theo địa bàn"},
              {key: "1", value: "Đặt lịch theo thiết bị"}
            ],
          model: "0",
        },
      },
      modeSelect: {
        options: {
          label: "Chế độ phát <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Khung giờ cố định:</b> Là chế độ lịch phát trong khoảng thời gian có hiệu lực. " +
            "Người dùng chỉ cần đặt giờ phát để các thiết bị phát thanh với nguồn phát được chọn khi đến lịch toàn bộ các ngày trong tuần." +
            "<br/><b>- Theo lịch phát đã thiết lập:</b> Là chế độ lịch phát trong các ngày chỉ định thuộc khoảng thời gian có hiệu lực." +
            "<br/><b>- Khẩn cấp phát ngay:</b> Là chế độ lịch phát 1 lần khẩn cấp ngay lập tức tại thời điểm thực hiện đặt lịch.'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "mode",
          items:
            [
              {key: "0", value: "Khung giờ cố định"},
              {key: "1", value: "Theo lịch phát đã thiết lập"},
              {key: "2", value: "Khẩn cấp phát ngay"},
            ],
          model: "0",
        },
      },
      modeSchedule: {
        options: {
          label: "Kiểu lịch " +
            "<span class='explain-modeSchedule' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>-Theo ngày trong tuần:</b> Lịch đặt cho các thiết bị phát thanh với nguồn phát được" +
            " chọn trong khoảng ngày hiệu lực và chứa các ngày trong tuần (thứ 2, thứ 3..) " +
            "<i><br/>(Ví dụ: Ngày bắt đầu-Ngày kết thúc là 01/10/2022 - 30/10/2022 với ngày phát được thọn là thứ 2, thứ 3, thứ 4, thời gian phát là 05:00 và 17:00, các thiết bị sẽ phát thanh " +
            "vào 05:00 sáng và 17:00 chiều thứ 2, thứ 3, thứ 4 trong khoảng hiệu lực từ ngày 01 đến 30 tháng 10, các ngày thứ 5,6,7 và chủ nhật sẽ không phát thanh)</i>" +
            "<br/><b>-Theo ngày trong tháng:</b> Lịch đặt cho các thiết bị phát thanh với nguồn phát được chọn trong khoảng ngày hiệu lực và chứa các ngày chỉ định (ngày 10,11,12)" +
            "<br/><i>(Ví dụ: Ngày bắt đầu-Ngày kết thúc là 01/10/2022 - 30/10/2022 với ngày phát được chọn là ngày 14,17,18, thời gian phát là 05:00 và 17:00, các thiết bị sẽ phát thanh" +
            " vào 05:00 sáng và 17:00 chiều các ngày 14,17,18 trong khoảng hiệu lực từ ngày 01 đến 30 tháng 10, các ngày còn lại không được chọn sẽ không phát thanh)</i>'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal:
            {
              label: 'col-sm-3',
              input: 'col-sm-9'
            }
        },
        data: {
          name: "modeSchedule",
          items:
            [
              {key: "0", value: "Theo ngày trong tuần"},
              {key: "1", value: "Theo ngày trong tháng"},
            ],
          model: "0",
        },
      },
      deviceInput: {
        data: {
          name: 'deviceIds',
          model: []
        },
        validator: {
          isValid: true,
          errorMessage: "",
          valid:
            function () {
              let value = that.deviceInput.data.model;
              if (value === "" || value.length == 0) {
                this.isValid = false;
                // that.showErrorMsg({message: 'Thiết bị phát không được để trống'})
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
        }
      },
      resetDevice: false,
      validDevice: false,
      selectedDateWeek:
        {
          options: {
            label: "Ngày phát",
          },
          data: {
            name: "selectedDateWeek",
            model: "",
            items:
              [
                {key: "2", value: "Thứ 2"},
                {key: "3", value: "Thứ 3"},
                {key: "4", value: "Thứ 4"},
                {key: "5", value: "Thứ 5"},
                {key: "6", value: "Thứ 6"},
                {key: "7", value: "Thứ 7"},
                {key: "1", value: "Chủ nhật"},
              ],
            validator:
              {
                isValid: true,
                errorMessage: "",
                valid:
                  function () {
                    let value = that.selectedDateWeek.data.model;
                    if ((value === "" || value.length == 0) &&
                      that.modeSelect.data.model == 1 && that.modeSchedule.data.model == 0) {
                      this.isValid = false;
                      this.errorMessage = "Ngày phát không được để trống";
                      that.scrollToValidate(that.$refs.selectedDateWeek.scrollHeight)
                    } else {
                      this.isValid = true;
                    }
                    return this.isValid;
                  },
              },
          },
        },
      validatorRangeTimes: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.timeRange;
            if ((value === "" || value.length == 0) && that.modeSelect.data.model != 2) {
              this.isValid = false;
              this.errorMessage = "Thời gian phát không được để trống";
              that.scrollToValidate(that.$refs.rangeTimes.scrollHeight)
            } else {
              var validRes = that.validateRangeTimeSorted();
              this.isValid = validRes.isValid;
              if (this.isValid) {
                this.errorMessage = "";
              } else {
                if (validRes.type == 0) {
                  this.errorMessage = "Thời gian bắt đầu phải lớn hơn hoặc bằng thời gian hiện tại";
                } else {
                  this.errorMessage = "Khoảng thời gian phát bị trùng nhau";
                }
                that.scrollToValidate(that.$refs.rangeTimes.scrollHeight)
              }
            }
            return this.isValid;
          },
      },
      validatorDates: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.dates;
            if (
              (value === "" || value.length == 0) &&
              that.modeSelect.data.model == 1 &&
              that.modeSchedule.data.model == 1
            ) {
              this.isValid = false;
              this.errorMessage = "Ngày phát phát không được để trống";
              that.scrollToValidate(that.$refs.rangeDates.scrollHeight)
            } else {
              this.isValid = true;
            }
            return this.isValid;
          },
      },
      validatorEndTimeUrgency: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.endTimeUrgency.getTime();
            if (value !== "" && that.modeSelect.data.model == 2) {
              if (value <= new Date()) {
                this.isValid = false;
                this.errorMessage = "Thời gian kết thúc phát phải lớn hơn thời gian hiện tại";
                that.scrollToValidate(that.$refs.endTimeUrgency.$el.scrollHeight)
              } else {
                this.isValid = true;
              }
            }
            return this.isValid;
          },
      },
      chooseFileData: {
        isShowModal: false,
        fileTable:
          {
            options: {
              fields: [
                {key: "name", label: "Tên", _style: 'width: 40%;'},
                {key: "url", label: "File", _style: 'width: 30%;'},
                {key: "size", label: "Dung lượng (Mb)", _style: 'width: 10%;'},
                {key: "action", label: "Thao tác", _style: 'width: 10%;'}
              ],
              slots:
                ["index", "name", "size", "url", "action"],
            },
            data: {
              items: [
                {name: 123, label: 555},
                {name: 1234, label: 4444}
              ]
            }
          }
      },
    }
  },
  computed: {
    checkDisableAddDate() {
      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (this.dates.length <= daysDiff) {
        return false;
      }
      return true;
    }
  },
  methods: {
    scrollToValidate(scrollHeight) {
      setTimeout(() => {
        window.scrollTo({left: 100, top: scrollHeight, behavior: "smooth"});
      }, 100);
    },
    changeSelectedDevice(value) {
      this.deviceInput.data.model = value;
    },
    clearSelectedAll() {
      this.resetDevice = false;
    },
    changeValidateDevice(value) {
      this.deviceInput.validator.isValid = !value;
    },
    chooseFile() {
      this.chooseFileData.isShowModal = true;
    },
    chooseFileSelected(value) {
      this.fileSelectedInput.data.model = value.id;
      this.fileSelectedInput.data.title = `${value.title} (${value.duration})`;
      this.chooseFileData.isShowModal = false;
    },
    closeModalChooseFile() {
      this.chooseFileData.isShowModal = false;
    },
    submitConfirm: function () {
      let that = this;
      that.isConfirm = false;
      that.exist.isShowModelExist = false;
      that.submitData();
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.validatorRangeTimes.valid();
      isValid &= that.selectedDateWeek.data.validator.valid();
      isValid &= that.validatorDates.valid();
      isValid &= that.channelDigitalSelect.data.validator.valid();
      isValid &= that.fileSelectedInput.data.validator.valid();
      isValid &= that.validatorEndTimeUrgency.valid();
      // if (that.scheduleBySelect.data.model == 1) {
        isValid &= that.deviceInput.validator.valid();
      // }

      if (!isValid) {
        return;
      } else {
        let res = that.setupDataSubmit();
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/schedule/add",
          dataSubmit: function () {
            return res;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              if (response.data.data.id) {
                that.exist.id = response.data.data.id;
                that.exist.msg = response.data.data.msg;
                that.exist.startTime = response.data.data.startTime;
                that.exist.endTime = response.data.data.endTime;
                that.exist.playDate = response.data.data.playDate;
                that.exist.devices = response.data.data.devices;
                that.exist.mode = response.data.data.modeSchedule;
                that.exist.locationName = response.data.data.locationName;
                that.exist.isShowModelExist = true;
              } else {
                that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
                that.$helper.setupErrorModel(response.data.data, that.$data);
              }
            } else {
              that.showSuccessMsg({message: "Thêm mới lịch phát thành công"});
              that.$router.push("/schedule-management/managed-shedule.html");
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    setupDataSubmit() {
      let res = {};
      let dates = [];
      for (let i = 0; i < this.dates.length; i++) {
        dates.push(this.$helper.formatDateDDMMYYYY(this.dates[i].date.getTime()));
      }
      let startTimes = [];
      let endTimes = [];
      let times = [];
      for (let i = 0; i < this.timeRange.length; i++) {
        var startTime = this.$helper.formatHHMM(this.timeRange[i].start.getTime());
        var endTime = this.$helper.formatHHMM(this.timeRange[i].end.getTime());
        startTimes.push(startTime);
        endTimes.push(endTime);
        times.push(startTime + " - " + endTime);
      }

      if (this.modeSelect.data.model == 2) {
        endTimes.push(this.$helper.formatHHMM(this.endTimeUrgency.getTime()));
      }

      res.dates = dates;
      res.startTimes = startTimes;
      res.endTimes = endTimes;
      res.fromDate = this.$helper.formatDateDDMMYYYY(this.minDate.getTime());
      res.toDate = this.$helper.formatDateDDMMYYYY(this.maxDate.getTime());

      res.typeSource = this.typeSourceSelect.data.model;
      res.mode = this.modeSelect.data.model;
      res.modeSchedule = this.modeSchedule.data.model;
      res.times = times;
      res.fileId = this.fileSelectedInput.data.model;
      res.channelDigitalId = this.channelDigitalSelect.data.model;
      res.devices = this.deviceInput.data.model;
      if (this.selectedDateWeek.data.model.length > 0) {
        res.selectedDateWeek = [];
        for (let i = 0; i < this.selectedDateWeek.data.model.length; i++) {
          res.selectedDateWeek.push(this.selectedDateWeek.data.model[i].key);
        }
      }
      res.isConfirm = this.isConfirm;
      // res.scheduleLocationCode = this.scheduleLocationCode.data.model;
      return res;
    },

    addTimeRange() {
      if (this.timeRange.length == 0) {
        this.timeRange.push(
          {
            start: this.$helper.plusDateTime(5, 'm').second(0).millisecond(0)._d,
            end: this.$helper.plusDateTime(13, 'm').second(0).millisecond(0)._d,
            isValid: false
          })
      } else {
        var rangeTimeSorted = this.sortRangeTime();
        var timeEnd = rangeTimeSorted[rangeTimeSorted.length - 1].end;
        this.timeRange.push({
          start: timeEnd,
          end: moment(timeEnd).add(10, 'm').second(0).millisecond(0).toDate(),
          isValid: false
        })
      }
    },
    changeTimeRange(event, index) {
      this.timeRange.splice(index, 1, event);
    },

    sortRangeTime(isClick) {
      var timeArr = this.timeRange;
      var sortedTime = [];
      var tempTimesArr = [];
      timeArr.forEach(function (each, index) {
        tempTimesArr.push({time: moment(each.start, "hh:mm").unix(), index: index});
      });
      tempTimesArr.sort(function (a, b) {
        return a.time - b.time;
      });

      tempTimesArr.forEach(function (t) {
        sortedTime.push(timeArr[t.index])
      });
      if (isClick) {
        this.timeRange = sortedTime;
      } else {
        return sortedTime;
      }
    },

    validateRangeTimeSorted() {
      var rangeTimeSorted = this.sortRangeTime();
      var response = {
        isValid: true,
      }
      var now = moment().second(0).millisecond(0)._d.getTime();
      var mode = this.modeSelect.data.model;
      var modeSchedule = this.modeSchedule.data.model;
      var minDate = new Date();

      if(modeSchedule == 1) {
        minDate = this.getMinDate(this.dates);
      }

      for (let i = 0; i < rangeTimeSorted.length; i++) {

        if(mode == 0) {
          var _from = new Date(this.dateRange.start.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
          if (_from < now) {
            response.isValid = false;
            response.type = 0;
            break;
          }
        } else if (mode == 1) {
          if(modeSchedule == 1) {
            var _from = new Date(minDate.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
            if (_from < now) {
              response.isValid = false;
              response.type = 0;
              break;
            }
          }
        }
        if (i > 0) {
          if (rangeTimeSorted[i].start.getTime() < rangeTimeSorted[i - 1].end.getTime()) {
            response.isValid = false;
            response.type = 1;
            break;
          }
        }
      }
      return response;
    },

    getMinDate(dates) {
      console.log(dates)

      let minDate = dates[0];

      for (let i = 1; i < dates.length; i++) {
        if (dates[i] < minDate) {
          minDate = dates[i];
        }
      }

      return minDate.date;
    },

    removeTimeRange(index) {
      this.timeRange.splice(index, 1);
    },
    addDate() {
      let that = this;

      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (daysDiff < this.dates.length) {
        return;
      }

      var date = new Date();
      date.setDate(this.dateRange.start.getDate());
      this.dates.push({date: date});
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
          btn.click();
        }, 50);
      });
    },
    removeDate(date, hide) {
      this.dates = this.dates.filter((d) => d !== date);
      hide();
    },
    dateSelected(e, date, toggle) {
      this.selectedDate = date;
      toggle({ref: e.target});
    },
    resetData() {
      this.modeSelect.data.model = "0";
      this.modeSchedule.data.model = "0";
      this.minDate = new Date();
      this.maxDate = new Date();
      this.endTimeUrgency = {};
      this.timeRange = [];
      this.dateRange = {
        start: this.minDate,
        end: this.maxDate,
      };
      this.resetTime();
      this.resetDevice = true;
      this.fileSelectedInput.data.model = '';
      this.fileSelectedInput.data.title = '';
      this.channelDigitalSelect.data.model = '';
    },
    resetTime() {
      this.startTimes = [];
      this.endTimes = [];
      this.selectedDateWeek.data.model = [];
      this.dates = [];
    },
    reloadTooltipExplain() {
      setTimeout(() => {
        const options = {
          // placement: 'right',
          boundary: 'window',
        }
        var elm = document.getElementsByClassName("explain");
        for (var each of elm) {
          new coreui.Tooltip(each, options);
        }
        var elmModeSchedule = document.getElementsByClassName("explain-modeSchedule");
        for (var each of elmModeSchedule) {
          new coreui.Tooltip(each, {
            placement: 'right',
          });
        }
        // $('[data-toggle="tooltip"]').tooltip(options);
      }, 100);
    }
  },
  created: function () {

  },
  mounted() {
    const options = {
      placement: 'bottom'
    }
    $('[data-toggle="tooltip"]').tooltip(options);
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.minDate = newValue.start;
        this.maxDate = newValue.end;
      }
      this.dates = [];
    },
    "scheduleBySelect.data.model": function () {
      this.districtCodeScheduleInput.data.model = null;
      this.wardCodeScheduleInput.data.model = null;
    },
    "modeSelect.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
      this.reloadTooltipExplain();
    },
    "modeSchedule.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
      this.reloadTooltipExplain();
    },
    'typeSourceSelect.data.model': function (value) {
      this.reloadTooltipExplain();
      if (value == 2) { /* Kênh Số Hóa */
        let that = this;
        setTimeout(() => {
          that.$refs.channelDigitalSelect.loadData();
        }, 50)
      } else {
        this.channelDigitalSelect.data.items = [];
      }
      this.fileSelectedInput.data.model = '';
      this.fileSelectedInput.data.title = '';
    },
    'districtCodeScheduleInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeScheduleInput.loadData();
        this.scheduleLocationCode.data.model = value;
        this.wardCodeScheduleInput.options.disabled = false;
      } else {
        this.wardCodeScheduleInput.data.items = [];
        this.wardCodeScheduleInput.options.disabled = true;
      }
      this.wardCodeScheduleInput.data.model = null
    },
    'wardCodeScheduleInput.data.model': function (value) {
      if (value) {
        this.scheduleLocationCode.data.model = value;
      } else {
        this.scheduleLocationCode.data.model = this.districtCodeScheduleInput.data.model;
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.btn-date:hover .btn-remove {
  display: inline-flex !important;
}

.btn-remove {
  display: none !important;
  position: absolute;
  width: 15px;
  height: 15px;
  background: red;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  right: -5px;
}

.custom-checkbox
.custom-control-input:indeterminate
~ .custom-control-label::before {
  border-color: unset;
  background-color: unset;
}

.form-group.input-error .card {
  border-color: #ff7070 !important;
}

.btn-time-ranger:hover ~ .btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
<style lang="scss">

#addSchedule {

  .group-select, .datepicker, .custom-input {
    padding: unset !important;
  }

  .modal-chooseFile {

    .modal-dialog {
      height: 90vh;

      .modal-content {
        height: 100%;

        .modal-body {
          height: 100%;
          overflow: auto;

          &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            background-color: rgba(127, 127, 127, .2) !important;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #39a2ff !important;
          }

          &::-webkit-scrollbar-track {
            --webkit-box-shadow: inset 0 0 6px rgba(127, 127, 127, .2);
            background-color: white !important
          }
        }
      }
    }
  }

  .input-error {
    #endTimeUrgencyPicker {
      border-color: #ff7070;
    }
  }

  .multiselect {
    min-height: 36px !important;
    margin-top: -2px;
    padding: unset !important;

    &.input-error .multiselect__tags {
      border-color: #ff7070;
    }

    .valid-error {
      animation: fade-down ease-out .2s;
      animation-fill-mode: forwards;
    }

    .multiselect__tags {
      padding-top: 0px !important;
      min-height: 36px !important;
    }


    .multiselect__tag {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
    }
  }

  .multiselect__input {
    line-height: unset !important;
    font-size: 14px !important;
    padding-top: 5px !important;
  }

  .multiselect__placeholder {
    padding-top: 7px !important;
    margin: 0 !important;
  }

  .override-custom {
    opacity: 0 !important;
  }

  .datepicker:after {
    //padding-left: 10px !important;
  }

}
</style>
<style>
/*.tooltip {*/
/*  max-width: unset !important;*/
/*  width: 500px !important;*/
/*}*/

/*.tooltip-arrow {*/
/*  max-width: unset !important;*/
/*  width: 500px !important;*/
/*}*/

.tooltip-inner {
  max-width: unset !important;
  width: 250px !important;
}
</style>
